var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWithGreyCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_6317)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_872_6317",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_872_6317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3906 39.2188H19.9219C18.6369 39.219 17.3551 39.0898 16.096 38.8331C13.6677 38.3357 11.3611 37.365 9.30771 35.9765C6.2554 33.9161 3.86615 31.0147 2.4295 27.6238C1.944 26.4754 1.57338 25.2818 1.32309 24.0604C1.06643 22.8012 0.937223 21.5194 0.9375 20.2344V19.7656C0.937254 18.4806 1.06641 17.1988 1.32309 15.9397C1.82068 13.5114 2.7914 11.2047 4.17984 9.15131C6.24031 6.09908 9.14171 3.70988 12.5325 2.27318C13.6809 1.78773 14.8746 1.41726 16.096 1.16707C17.3551 0.910239 18.6369 0.780955 19.9219 0.781251H20.3906C21.6756 0.780955 22.9574 0.910239 24.2165 1.16707C26.6448 1.6644 28.9514 2.63498 31.0048 4.02351C34.057 6.08395 36.4462 8.98536 37.8828 12.3762C38.3683 13.5246 38.739 14.7182 38.9893 15.9396C39.246 17.1988 39.3752 18.4806 39.375 19.7656V20.2344C39.3752 21.5194 39.2461 22.8012 38.9894 24.0603C38.4918 26.4886 37.5211 28.7953 36.1327 30.8487C34.0723 33.9009 31.1709 36.2901 27.7802 37.7268C26.6317 38.2123 25.4381 38.5829 24.2166 38.8331C22.9575 39.0899 21.6757 39.219 20.3906 39.2188ZM19.9666 21.3515L26.7152 28.1002L28.2152 26.5997L21.4665 19.8515L28.2152 13.1028L26.7152 11.6036L19.9666 18.3519L13.2179 11.6036L11.7186 13.1028L18.4669 19.8515L11.7186 26.5997L13.2179 28.1002L19.9666 21.3515Z",
    fill: "#AAAAAA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_6317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithGreyCircle);
export default __webpack_public_path__ + "static/media/CloseWithGreyCircle.dbbfb0cbaed57522772a988f99ce5ba5.svg";
export { ForwardRef as ReactComponent };